const ACTION_LABELS: Record<string, string> = {
  'user.suspended': 'User Suspended',
  'user.activated': 'User Activated',
  'user.promoted': 'User Promoted',
  'user.demoted': 'User Demoted',
  'user.info_updated': 'User Info Updated',
  'user.password_reset': 'Password Reset',
  'membership.added': 'Membership Added',
  'membership.role_updated': 'Membership Role Updated',
  'workspace.suspended': 'Workspace Suspended',
  'workspace.activated': 'Workspace Activated',
}

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action
}

import type { Theme } from '@/types/theme'

export type ActionColorKind = 'error' | 'success' | 'warning' | 'purple' | 'info'

export function actionColorKind(action: string): ActionColorKind {
  if (action.includes('suspend') || action.includes('demoted')) return 'error'
  if (action.includes('activated') || action.includes('promoted')) return 'success'
  if (action.includes('password')) return 'warning'
  if (action.includes('membership')) return 'purple'
  return 'info'
}

export function actionColor(action: string, theme: Theme): { bg: string; text: string } {
  const kind = actionColorKind(action)
  switch (kind) {
    case 'error': return { bg: theme.errorBackground, text: theme.errorText }
    case 'success': return { bg: theme.successBackground, text: theme.successText }
    case 'warning': return { bg: theme.warningBackground, text: theme.warningText }
    case 'purple': return { bg: theme.purpleBackground, text: theme.purpleText }
    case 'info': return { bg: theme.infoBackground, text: theme.infoText }
  }
}
